export function getPixelPositionMarker(width: number, height: number) {
	return {
		x: -(width / 2),
		y: -(height / 2),
	}
}

export function getPixelPositionWindow(
	width: number,
	height: number,
	shortestPosition: 'top' | 'bottom' | 'left' | 'right',
) {
	if (shortestPosition === 'top') {
		return {
			x: -(width / 2),
			y: 28,
		}
	} else if (shortestPosition === 'bottom') {
		return {
			x: -(width / 2),
			y: -(height + 28),
		}
	} else if (shortestPosition === 'left') {
		return {
			x: 55,
			y: -(height / 2),
		}
	} else {
		return {
			x: -width - 55,
			y: -(height / 2),
		}
	}
}
